import * as types from "./actionTypes";
import criteriaBovenLokaalApi from "../api/criteriaBovenLokaalApi";
import * as constants from "../constants/DomainConstants";
import * as ajax from "./ajaxCounterActions";
import * as exception from "./exceptionActions";
import * as beads from "./beadActions";


// ----------------------------------------------------------------------------
export function criteriaBovenLokaalLoaded(criteria, errors, hasValidationErrors) {
	return {
		type: types.CRITERIA_BOVEN_LOKAAL_LOADED,
		body: {
			item: criteria,
			errors: errors,
			hasValidationErrors
		}
	};
}

export function loadCriteriaBovenLokaal(dossierId) {
	return (dispatch) => {
		dispatch(ajax.started());

		return criteriaBovenLokaalApi.get(dossierId)
			.then(response => {
				dispatch(ajax.ended());
				dispatch(criteriaBovenLokaalLoaded(response.data.item, response.data.validationResults, response.data.hasValidationErrors));
				dispatch(beads.beadsLoaded(response.data.item.beadModels));
			})
			.catch(error => {
				dispatch(ajax.failed(error));
				dispatch(exception.throwException(error));
			});
	};
}

export function getEmptyBereikDoelgroep(dossierId, inTheFuture) {
	return (dispatch) => {
		dispatch(ajax.started());
		return criteriaBovenLokaalApi.loadEmptyBereikDoelgroep(dossierId, inTheFuture)
			.then(response => {
				dispatch(ajax.ended());
				return response.data;
			})
			.catch(error => {
				dispatch(ajax.failed(error));
				dispatch(exception.throwException(error));
			});
	};
}

// ----------------------------------------------------------------------------
export function criteriaBovenLokaalSaved(criteria, errors, hasValidationErrors) {
	return {
		type: types.CRITERIA_BOVEN_LOKAAL_SAVED,
		body: {
			item: criteria,
			errors: errors,
			hasValidationErrors
		}
	};
}

export function saveCriteriaBovenLokaal(criteria, documenten) {
	return (dispatch) => {
		dispatch(ajax.started());
		return criteriaBovenLokaalApi.save(criteria, documenten)
			.then((response) => {
				dispatch(ajax.ended());
				if (response.data.concurrencyException) {
					dispatch(criteriaBovenLokaalSaved(response.data.item, response.data.validationResults, response.data.hasValidationErrors));
					return constants.HAS_CONCURRENCY_EXCEPTION;
				}

				if (response.data.hasValidationErrors) {
					dispatch(criteriaBovenLokaalSaved(response.data.item, response.data.validationResults, response.data.hasValidationErrors));
					return constants.HAS_VALIDATION_ERRORS;
				}
				if (Object.keys(response.data.validationResults).length !== 0) {
					dispatch(criteriaBovenLokaalSaved(response.data.item, response.data.validationResults, response.data.hasValidationErrors));
					dispatch(beads.beadsLoaded(response.data.item.beadModels));
					return constants.HAS_VALIDATION_ERRORS_SAVED;
				}

				dispatch(criteriaBovenLokaalSaved(response.data.item, response.data.validationResults, response.data.hasValidationErrors));
				dispatch(beads.beadsLoaded(response.data.item.beadModels));
				return constants.SUCCESS;

			})
			.catch(error => {
				dispatch(ajax.failed(error));
				dispatch(exception.throwException(error));
			});
	};
}
